<div class="min-h-full bg-[#fafaf7] font-sans">
  <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

    <!-- Filters -->
    <div class="bg-white rounded-2xl border border-stone-100 shadow-sm px-5 py-4">
      <div class="flex flex-col sm:flex-row gap-3">

        <!-- Search -->
        <div class="relative flex-1">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none"
            fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
          </svg>
          @if (isFiltering()) {
            <div class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-stone-300 border-t-primary-400 rounded-full animate-spin"></div>
          }
          <input type="search" placeholder="Rechercher un document…"
            [value]="searchQuery()"
            (input)="onSearch($any($event.target).value)"
            class="w-full pl-9 pr-4 py-2 border border-stone-200 rounded-xl text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all" />
        </div>

        <!-- Category filter -->
        <select [value]="selectedPageCode()" (change)="onCategoryFilter($any($event.target).value)"
          class="pl-3 pr-8 py-2 border border-stone-200 rounded-xl text-sm text-stone-700 bg-white outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all">
          <option value="">Toutes les catégories</option>
          @for (cat of categories; track cat.code) {
            <option [value]="cat.code">{{ cat.label }}</option>
          }
        </select>

        <!-- Add button -->
        @if (permService.can('marketing', 'documents', 'create')) {
          <button (click)="openAddForm()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
            <span class="material-icons text-base">add</span>
            Ajouter
          </button>
        }

      </div>
    </div>

    <!-- Error -->
    @if (errorMessage()) {
      <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-2">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }

    <!-- Loading skeleton -->
    @if (isLoading()) {
      <div class="bg-white rounded-2xl border border-stone-100 overflow-hidden">
        <div class="p-4 space-y-3">
          @for (i of [1,2,3,4,5]; track i) {
            <div class="flex gap-4 items-center">
              <div class="h-3 bg-stone-100 rounded-full flex-1 animate-pulse"></div>
              <div class="h-3 bg-stone-100 rounded-full w-28 animate-pulse"></div>
              <div class="h-3 bg-stone-100 rounded-full w-8 animate-pulse"></div>
              <div class="h-3 bg-stone-100 rounded-full w-16 animate-pulse"></div>
              <div class="h-3 bg-stone-100 rounded-full w-12 animate-pulse"></div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Table -->
    @if (!isLoading()) {
      <div class="bg-white rounded-2xl border border-stone-100 overflow-hidden shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-3 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[48px] flex-shrink-0">ID</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider flex-1">Titre</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-32 flex-shrink-0">Catégorie</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-20 flex-shrink-0">Statut</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">
              @if (documents().length === 0) {
                <tr>
                  <td colspan="4" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <span class="material-icons text-4xl text-stone-200">folder_open</span>
                      <p class="text-stone-400 text-sm">Aucun document trouvé</p>
                    </div>
                  </td>
                </tr>
              }
              @for (doc of documents(); track doc.public_document_id) {
                <tr class="hover:bg-stone-50 transition-colors duration-150 cursor-pointer"
                  (click)="onRowClick(doc.public_document_id)">
                  <td class="px-3 py-3 w-[48px] flex-shrink-0">
                    <span class="text-xs font-mono text-stone-400">#{{ doc.public_document_id }}</span>
                  </td>
                  <td class="px-4 py-3 min-w-0 flex-1">
                    <p class="font-semibold text-stone-800 text-xs truncate">{{ doc.public_document_first_title }}</p>
                  </td>
                  <td class="px-4 py-3 w-32 flex-shrink-0">
                    <span class="inline-flex items-center px-2 py-0.5 rounded-md bg-primary-50 text-primary-700 text-xs font-medium">
                      {{ getCategoryLabel(doc.page_code) }}
                    </span>
                  </td>
                  <td class="px-4 py-3 w-20 flex-shrink-0">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(doc.public_document_status || 'ACTI')">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="(doc.public_document_status || 'ACTI') === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                      {{ doc.public_document_status_label || statusLabel(doc.public_document_status || 'ACTI') }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      @if (pagination().totalPages > 1) {
        <div class="flex items-center justify-between">
          <p class="text-xs text-stone-400">
            Page <span class="font-semibold text-stone-600">{{ pagination().page }}</span> sur
            <span class="font-semibold text-stone-600">{{ pagination().totalPages }}</span>
            · <span class="font-semibold text-stone-600">{{ pagination().total }}</span> documents
          </p>
          <div class="flex items-center gap-1">
            <button (click)="onPageChange(pagination().page - 1)" [disabled]="pagination().page === 1"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
              </svg>
            </button>
            @for (p of pageNumbers(); track p) {
              @if (p === '...') {
                <span class="w-8 h-8 flex items-center justify-center text-xs text-stone-400">…</span>
              } @else {
                <button (click)="onPageChange($any(p))"
                  class="w-8 h-8 rounded-xl text-xs font-medium transition-colors"
                  [class]="$any(p) === pagination().page ? 'bg-primary-600 text-white shadow-sm' : 'text-stone-500 hover:bg-stone-100'">
                  {{ p }}
                </button>
              }
            }
            <button (click)="onPageChange(pagination().page + 1)" [disabled]="pagination().page === pagination().totalPages"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
              </svg>
            </button>
          </div>
        </div>
      }
    }

  </div>
</div>

<!-- Add / Edit modal -->
@if (showForm()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-md mx-4">
      <div class="flex items-center justify-between mb-5">
        <h3 class="text-base font-semibold text-stone-800">
          {{ editingDocument() ? 'Modifier le document' : 'Ajouter un document' }}
        </h3>
        <button (click)="closeForm()" class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-stone-100 transition-all">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      @if (formError()) {
        <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-xs text-red-700 mb-4">{{ formError() }}</div>
      }

      <div class="space-y-4">
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Catégorie <span class="text-red-500">*</span></label>
          <select [value]="formData().pageCode" (change)="updateField('pageCode', $any($event.target).value)"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all">
            @for (cat of categories; track cat.code) {
              <option [value]="cat.code">{{ cat.label }}</option>
            }
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Titre <span class="text-red-500">*</span></label>
          <input type="text" [value]="formData().title"
            (input)="updateField('title', $any($event.target).value)"
            placeholder="Titre du document"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 placeholder-stone-400 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"/>
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Ordre d'affichage</label>
          <input type="number" [value]="formData().order" min="1"
            (input)="updateField('order', +$any($event.target).value)"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"/>
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Fichier</label>
          @if (editingDocument()?.file_url && !selectedFile()) {
            <div class="flex items-center gap-2 p-2.5 rounded-xl border border-stone-200 bg-stone-50 mb-2">
              <span class="material-icons text-sm text-stone-400">attach_file</span>
              <span class="text-xs text-stone-600 flex-1 truncate">{{ editingDocument()?.file_name || 'Fichier actuel' }}</span>
              <a [href]="editingDocument().file_url" target="_blank" class="text-xs text-primary-600 hover:text-primary-800 font-medium flex-shrink-0">Voir</a>
            </div>
          }
          <label class="flex items-center gap-3 w-full border border-dashed border-stone-300 rounded-xl px-3 py-3 cursor-pointer hover:border-primary-300 hover:bg-primary-50 transition-all">
            <span class="material-icons text-stone-400 text-lg">upload_file</span>
            <span class="text-xs text-stone-500">
              @if (selectedFile()) {
                <span class="text-primary-600 font-medium">{{ selectedFile()!.name }}</span>
              } @else {
                {{ editingDocument()?.file_url ? 'Remplacer le fichier (optionnel)' : 'Choisir un fichier (optionnel)' }}
              }
            </span>
            <input type="file" class="hidden" (change)="onFileChange($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"/>
          </label>
        </div>
      </div>

      <div class="flex items-center justify-end gap-2 mt-6">
        <button type="button" (click)="closeForm()" [disabled]="isSaving()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving()"
          class="inline-flex items-center gap-2 px-5 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 transition-colors text-sm font-semibold">
          @if (isSaving()) {
            <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          } @else {
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
            </svg>
          }
          {{ isSaving() ? 'Enregistrement…' : (editingDocument() ? 'Modifier' : 'Ajouter') }}
        </button>
      </div>
    </div>
  </div>
}

